import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import useAuthorized from "hooks/useAuthorized";
import CampaignActivityModal from "routes/constant_contact/components/CampaignActivityModal";
import DeleteCampaignActivityModal from "routes/constant_contact/components/DeleteCampaignActivityModal";

export function CampaignActivityTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = useAuthorized([
    ACL_RELATIONSHIPS.constantContactCampaigns.edit,
  ]);
  const canDelete = useAuthorized([
    ACL_RELATIONSHIPS.constantContactCampaigns.delete,
  ]);

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Campaign activity actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {canEdit && (
        <CampaignActivityModal
          activity={original}
          open={editOpen}
          onOpenChange={setEditOpen}
        />
      )}
      {canDelete && (
        <DeleteCampaignActivityModal
          activity={original}
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
        />
      )}
    </>
  );
}
